export enum AgentStateType {
  PENDING = 'PENDING',
  DEPLOYING = 'DEPLOYING',
  DEPLOY_FAILED = 'DEPLOY_FAILED',
  DEPLOYED = 'DEPLOYED',
  DATA_REFRESHING = 'DATA_REFRESHING',
  REMOVING = 'REMOVING',
  REMOVE_FAILED = 'REMOVE_FAILED'
}

export const AGENT_READY_STATES: AgentStateType[] = [AgentStateType.DEPLOYED, AgentStateType.DATA_REFRESHING]
export const AGENT_ACTIVATING_STATES: AgentStateType[] = [AgentStateType.PENDING, AgentStateType.DEPLOYING]
export const AGENT_IN_PROGRESS_STATES: AgentStateType[] = [
  AgentStateType.PENDING,
  AgentStateType.DEPLOYING,
  AgentStateType.REMOVING,
  AgentStateType.DATA_REFRESHING
]

// Deploy and removal finish in minutes, so they are watched closely. A data
// refresh is a routine task that runs far longer, so it is watched at a slower
// rate rather than held at the same cadence.
export const AGENT_FAST_POLL_STATES: AgentStateType[] = [
  AgentStateType.PENDING,
  AgentStateType.DEPLOYING,
  AgentStateType.REMOVING
]
export const AGENT_SLOW_POLL_STATES: AgentStateType[] = [AgentStateType.DATA_REFRESHING]

export const AGENT_FAST_POLL_INTERVAL_MS = 5000
export const AGENT_SLOW_POLL_INTERVAL_MS = 60000

// After this duration, recheck unfinished operations on focus instead of polling continuously.
export const AGENT_MAX_POLL_DURATION_MS = 60 * 60 * 1000

export interface ConnectionI {
  id?: string
  created_at?: string
  default_user_role_id: string
  domain: string
  enabled: boolean
  external_sso_config_id: string | null
  public_certificate: string
  record_name: string
  record_value: string
  acs_url_path: string
  entity_id: string
  sso_url: string
  tenant_id: string
  updated_at?: string
  verified: string
  rejection_reason?: string | null
  isEdit?: boolean
}
